<template>
  <!--上传的-->
  <div>
    <div class="ay-content-list"  v-infinite-scroll="loadMore"  infinite-scroll-disabled="busy" infinite-scroll-distance="10" infinite-scroll-throttle-delay="1000">
     <!-- <button  v-if="userId =='54288843' || userId == '13286101'"><a href="./home.html">视频合成</a></button>-->
     <!-- <input type="file" v-if="userId =='54288843' || userId == '13286101'">-->
      <div class="ay-link ay-cor" v-if="MyUpload" v-for="(item,ind) in MyUpload">
      <!--  <div class="ay-close" :attr-id="item.file.uuid" :attr-type="item.file.uuid"></div>-->
      <p class="ay-title-time" v-if="item.file_type == 'image'">{{item.file.upload_time|datetime}}</p>
        <p class="ay-title-time" v-if="item.file_type == 'video'">{{item.file.upload_datetime|datetime}}</p>
        <div class="ay-inr" v-if="item.file">
          <div class="ay-pic-box" @click="video(item.file.status,item.ids,item.file_id,item.file_type,item,item.file.is_edit)">
            <em v-if="item.is_recommend == 1"></em>
            <img v-if="item.file_type == 'video'" class="ay-pic" :src="item.file.thumb_url +'?p=3&o=2&w=350&h=197'" alt=""/>
            <img v-if="item.file_type == 'image'" class="ay-pic" :src="(item.file.status === 'approved'?   item.file.image_url:(item.file.status === 'rejected'? reject_img :pngSds)) +'?p=3&o=2&w=350&h=197'" alt=""/>
            <i class="ay-pic-t" v-if="item.file_type == 'video'">{{item.file.time_span|formatSeconds}}</i>
          </div>
          <p class="ay-title">{{item.file.title}}</p>
           <div class="btn-ay">
            <a v-if="item.file.status == 'approved'" href="javascript:void(0);" class="btn-ay-red btn-admin-work" @click="edit(item.file_id,item.file_type,item)">编辑</a>
          </div>
        </div>
        <div class="ay-inr-bottom" v-if="item.file">
           <span class="icon-ygs" v-if="item.file.status == 'approved'">
              <i style="font-style: normal" v-if="item.file.is_edit == '1'">审核中（编辑）</i>
              <i style="font-style: normal" v-else>审核通过</i>
          </span>
          
           <span class="icon-ygs" v-if="item.file.status == 'none' && item.file.audit_level === 0">
            <i style="font-style: normal">上传成功</i>
          </span>
          <span class="icon-ygs" v-if="item.file.status == 'none'  && item.file.audit_level !== 0">
            <i style="font-style: normal">审核中</i>
          </span>
          <span class="icon-ygs" v-if="item.file.status == 'rejected'">
              审核未通过
          </span>
         <!--  <span v-if="item.file_type == 'video'" style="font-size: 14px;color: #999">
              播放数:{{item.file.visit_num}}
            </span>
            <span  v-if="item.file_type == 'image'" style="font-size: 14px;color: #999">
              浏览数:{{item.file.visit_num}}
            </span>-->
        </div>
      </div>
      <!-- load -->
      <div class="content index-content" v-show="!busy" style="padding-top: 5px">
        <div class="id-content-inner">
          <div class="loader">
            <div class="loader-inner ball-pulse" style="display: block">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="foll_div" v-if="MyUpload.length == 0">
        <div class="content index-content">
          <div class="id-content-inner">
            <div class="loader">
              <div class="loader-inner ball-pulse" style="display: block">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
       <!-- <img class="loading-currency" style="width: 40px;height:40px;"  src="../../../static/dist/img/Loading.jpg" alt=""/>-->
      </div>
    </div>

    <div class="sing-modal upload-modal large-info-modal modal fade" id="editModal" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <div class="group">
                  <label>名称</label>
                  <div class="pl-ipbox">
                    <input type="text" id="titleName" placeholder="请输入名称"/>
                  </div>
                </div>
                <div class="group">
                  <label>描述</label>
                  <div class="pl-ipbox">
                    <textarea rows="3" id="descriptionName" placeholder="请输入描述信息"></textarea>
                  </div>
                </div>
                <div class="btn-modal-tw">
                  <a href="javascript:void(0);" class="btn-pl-start" @click="editcComplete()">完成</a>
                  <a href="javascript:void(0);" class="btn-pl-start" data-dismiss="modal">取消</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--删除-->
    <div class="sing-modal upload-modal large-info-modal modal fade" id="editModals" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <h3 class="Prompt-p">你确定要删除上传文件？  </h3>
                <div class="btn-modal-tw">
                  <a href="javascript:void(0);" class="btn-pl-start" @click="DelFile">完成</a>
                  <a href="javascript:void(0);" class="btn-pl-start" data-dismiss="modal">取消</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="picture-content" @click="pictureHide">
      <div class="picture-content-div">
        <img class="picture-img" src="../../../static/dist/img/d.png" alt=""/>
      </div>
      <div class="picture-ph">
        <h3 class="picture-h3">详情title</h3>
        <p  class="picture-p">详情title详情title详情title</p>
      </div>
    </div>
    <Filedetails :fileItem="fileItem" :data="data" :tops = "tops"></Filedetails>
  </div>
</template>

<script>
  import Filedetails from '../template/filedetails.vue'
  export default {
    props: [
      'userId',
      'initUtil'
    ],
    data ()
  {
    return {
      MyUpload: [],
      page: '0',
      pagesize: '10',
      id: '',
      ID: '',
      ind: '',
      FileByUserid: null,
      busy : false,
      file_type: '',
      total: '',
      fileItem: null,
      tops: '0',
      data: '',
      globalUrl: API.GlobalUrl,
      pngSds: API.GlobalUrl + 'static/dist/img/audit_1.jpg',
      reject_img:   API.GlobalUrl+'static/dist/img/reject_1.jpg'
    }
  },
  components:{   //渲染页面
    Filedetails: Filedetails
  },
  methods: {
    //操作按钮事件
    pictureHide(){
      $('.picture-content').hide();
    },
    loadMore(){
      this.busy = true;
      // 多次加载数据
      setTimeout(() => {
        this.page ++;
      this.ajaxMore(true);
    }, 500)

    },
    ajaxMore(flag){
      var that = this;
      that.FileByUserid = {
        page: that.page,
        pagesize : that.pagesize,
        version: 2
      };
      this.$http.get(API.GetUploadFileForMe, {params: that.FileByUserid})
        .then(function (res) {
        //console.log(res)
          if(res.code == 0){
            if(flag){
            for(var i=0;i<res.data.length;i++){
              that.MyUpload.push(res.data[i])
            }
            if (res.data.length === 0 || that.MyUpload.length === res.total) {
              that.busy = true
            } else {
              that.busy = false
            }
           }
            if(res.total == 0){
              $('.foll_div').html('您还没有上传过文件！')
            }
          //   console.log(that.MyUpload)
        }
      })
    },
    //视频跳转
    video(val,id,uuid,type,item,status){
      var that = this;
      if(val == 'approved'){
        if(type == 'video'){
          this.data = new Date();
          that.fileItem = {
            file_type: 'video',
            file_id: item.file_id,
            activity_id: item.ids,
            file: item.file,
            activity_mini: {
              title: ''
            }
          };
          that.setShareInfo(that.fileItem);
        }else if(type == 'image'){
          this.data = new Date();
          that.fileItem = {
            file_type: 'image',
            file_id: item.file_id,
            activity_id: item.ids,
            activity_mini: {
              title: ''
            }
          };
        }
        $('.preview-file').addClass('preview-active');
        // $('.dl-video-title').show();
        this.tops = $(document).scrollTop();
      }
    },

    /**
     * 设置分享信息
     * @param {[type]} fileInfo [description]
     */
    setShareInfo: function(item) {
      var dataName = {
        title: item.file.title,
        // desc: this.removeTAG(item.file.description, 110),
        desc: '央视喊你上电视啦',
        imgAddress: item.file.thumb_url,
        Retain: '',// 保留
        url: API.UrlName + 'videoName/' + item.activity_id +'/' + item.file_id +'/video'
      };

      this.weixinShare(dataName)
    },

    //删除s上传文件
    DelFile(){
      var that = this;
      $('#editModals').modal('hide');
      //删除视频
      var edit;
      if(that.file_type == '1'){
        edit = API.DelEteVideo
      }else{
        //删除图片
        edit = API.DelEteImage
      }
      this.$http.get(edit, {params: {fileId: that.id}})
        .then(function (res) {
       // console.log(res)
        if(res.code == 0){
          $('#editModals').modal('hide');
          $('.ay-close').eq(that.ind-1).parents('.ay-link').remove();
        }else{
          alert('删除失败，该文件不存在')
        }
      })
    },
    //显示编辑
    edit(ind,file_type,data){
    //console.log(data);
      $('.btn-modal-tw').attr('data-id',ind).attr('file_type',file_type);
      $('#editModal').modal('show');
      $('#titleName').val(data.file.title);
      $('#descriptionName').val(data.file.description);
    },
    editcComplete(){  //编辑
      //title  description
      var that = this;
      //不能为空
      if($('#titleName').val() == ''){
        $('#titleName').focus()
      }else if($('#descriptionName').val() ==''){
        $('#descriptionName').focus()
      }else{
        //传参数
        var ActivityFile = {
          title: $('#titleName').val(),
          description: $('#descriptionName').val(),
          fileId: $('.btn-modal-tw').attr('data-id')
        };
        var edit;
        //判断类型  是图片还是视频
        if($('.btn-modal-tw').attr('file_type') == 'video'){
          edit = API.UpdataVideoAudit;
        }else{
          edit = API.UpdataImageAudit;
        }
        $.ajax({
          'url': edit,
          'data': ActivityFile,
          'type': 'POST',
          'dataType': 'json',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          success: function(res){
           // console.log(res)
            if(res.code == '0'){
              $('#editModal').modal('hide');
              $('#Prompt').modal('show');
            }else{
              console.log(res.msg)
            }
          }
        });
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = true;
    next();
  },
  created:function(){
    $('.icon-back').removeClass('pointerEve');
  },
  mounted: function () {
      this.userId =  this.getCookie('userSeqId')
    $('#picture').modal('show');
    //操作DOM
    $('.icon-back').show();
    var that = this;
    //滚动事件，加载数据
    $(window).scroll(function () {
      if ($(window).scrollTop() > 1000) {
        $('.back-top').show();
      } else {
        $('.back-top').hide();
      }
    });

      $('.nav').children('.id-nav-recom').eq(2).addClass('nav-on').siblings().removeClass('nav-on')
      $('.nav').find('.id-nav-recom').eq(2).addClass('router-link-exact-active').siblings().removeClass('router-link-exact-active')

    //显示提示框，并传值
    $('.ay-content-list').on('click','.ay-close',function () {
      that.id = $(this).attr('attr-id');
      that.ID = $(this).attr('id');
      that.ind = $(this).parents().index();
      that.file_type = $(this).attr('attr-type');
      $('#editModals').modal('show');
    });
    this.initUtil.stopBodyScroll(false);
    //微信分享
    let metas = $('head').children('meta');
  }

  }
</script>

<style>
 .picture-content{
   display: none;
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background: rgba(0,0,0,1);
   z-index: 99;
 }
 .picture-content-div{
   width: 90%;
   height: 100%;
   margin: 0 auto;
 }
.picture-content img{
  width: 100% ;
  height: auto;
  max-height: 80%;
  margin-bottom: 10px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.picture-ph h3{
  position: fixed;
  font-size: 15px;
  margin-bottom: 10px;
  top: 10px;
  width: 90%;
  left: 5%;
  color: #fff;
}
 .picture-ph p {
   position: fixed;
   bottom: 10px;
   width: 90%;
   left: 5%;
   color: #fff;
   font-size: 13px;
   line-height: 20px;
 }
</style>



// WEBPACK FOOTER //
// src/components/myActivity/upload.vue